export let closeButton = "qhlP_d";
export default {closeButton};